// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__29Fcb","title":"BackImages_title__ep-hh","images":"BackImages_images__3w9dd"};